<template>
    <record-editor
        id="user-editor"
        :record="edited_record"
        :title="page_title"
        right-panel-class="uk-width-3-10"
        left-panel-class="uk-width-7-10"
        :highlight-color="(edited_record||{}).hex_color"
        :can-view-data="can_view_record_data"
        :can-edit-data="can_edit_record_data"
        :can-delete-data="can_delete_data"
    >
        <div v-if="!!edited_record" slot="right-panel">
            <div v-if="!can_edit_record_data">
                <h1>
                    {{ edited_record.first_name }} {{ edited_record.last_name }} ({{ edited_record.initials }})
                </h1>
            </div>
            <div v-else class="uk-margin-bottom">
                <div class="uk-grid uk-grid-small">
                    <div class="uk-width-2-5">
                        <form-input
                            id="first_name"
                            v-model="edited_record.first_name"
                            name="first_name"
                            :error="has_error('first_name')"
                            :required="true"
                            placeholder="First Name"
                            width="1-1"
                            @input="save_field"
                        />
                    </div>
                    <div class="uk-width-2-5">
                        <form-input
                            id="last_name"
                            v-model="edited_record.last_name"
                            name="last_name"
                            :error="has_error('last_name')"
                            :required="true"
                            placeholder="Last Name"
                            width="1-1"
                            @input="save_field"
                        />
                    </div>
                    <div class="uk-width-1-5">
                        <form-input
                            id="initials"
                            v-model="edited_record.initials"
                            name="initials"
                            :error="has_error('initials')"
                            :required="true"
                            placeholder="Initials"
                            width="1-1"
                            @input="save_field"
                        />
                    </div>
                </div>
                <div v-if="!!edited_record && !edited_record.proxy" class="uk-grid uk-grid-small">
                    <div class="uk-width-1-1">
                        <password-field
                            v-if="me||is_db_admin_active"
                            :record="edited_record"
                            :editable="me"
                        />
                    </div>
                    <div class="uk-width-1-1 uk-margin-top">
                        <button
                            v-if="!edited_record.google_api_oauth_url"
                            type="button"
                            class="uk-button uk-button-primary uk-width-1-1"
                            @click.prevent="disconnect_google"
                        >
                            <img src="/img/google-logo.png" style="height: 1.5em; vertical-align: middle;" />
                            <span>Connected</span>
                        </button>
                        <a
                            v-else
                            :href="edited_record.google_api_oauth_url"
                            class="uk-button uk-button-link uk-width-1-1"
                        >
                            <img src="/img/google-logo.png" style="height: 1.5em; vertical-align: middle;" />
                            <span>Not Connected</span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="uk-accordion uk-margin-top">
                <h3 class="uk-accordion-title">
                    Office Management
                </h3>
                <div class="uk-accordion-content">
                    <div class="uk-grid uk-grid-small">
                        <div class="uk-width-3-5 uk-text-right lam-label-column">
                            <div class=" uk-form-controls-text">Studio</div>
                        </div>
                        <div class="uk-width-2-5">
                            <form-select
                                id="studio_id"
                                name="studio_id"
                                v-model="edited_record.studio_id"
                                :options="studios"
                                :editable="can_edit_record_data"
                                :required="true"
                                width="1-1"
                                @input="save_field"
                            />
                        </div>

                        <div v-if="can_edit_sensitive_data" class="uk-width-3-5 uk-text-right lam-label-column">
                            <div class="uk-form-controls-text">Current Billing Rate</div>
                        </div>
                        <div v-if="can_edit_sensitive_data" class="uk-width-2-5">
                            <form-input
                                id="billing_rate"
                                v-model="edited_record.billing_rate"
                                type="float"
                                name="billing_rate"
                                glyph="dollar"
                                :error="has_error('billing_rate')"
                                :required="true"
                                width="1-1"
                                @input="save_field"
                            />
                        </div>

                        <div v-if="can_edit_sensitive_data" class="uk-width-3-5 uk-text-right lam-label-column">
                            <div class="uk-form-controls-text">Annual Utilization Rate</div>
                        </div>
                        <div v-if="can_edit_sensitive_data" class="uk-width-2-5">
                            <form-input
                                id="annual_utilisation_rate"
                                v-model="edited_record.annual_utilisation_rate"
                                type="float"
                                name="annual_utilisation_rate"
                                glyph="percent"
                                :error="has_error('annual_utilisation_rate')"
                                :required="true"
                                width="1-1"
                                @input="save_field"
                            />
                        </div>

                        <div v-if="!!edited_record && !edited_record.proxy" class="uk-width-3-5 uk-text-right lam-label-column">
                        </div>
                        <div v-if="!!edited_record && !edited_record.proxy" class="uk-width-2-5">
                            <form-checkbox
                                id="on_leave"
                                v-model="edited_record.on_leave"
                                name="on_leave"
                                :editable="can_edit_sensitive_data"
                                :error="has_error('on_leave')"
                                @input="save_field"
                            >
                                On Leave
                            </form-checkbox>
                        </div>
                        <div v-if="!!edited_record && !!edited_record.on_leave && !edited_record.proxy" class="uk-width-3-5 uk-text-right lam-label-column">
                            <div class="uk-form-controls-text">
                                Since
                            </div>
                        </div>
                        <div v-if="!!edited_record&&!!edited_record.on_leave" class="uk-width-2-5">
                            <form-date-input
                                id="on_leave_since"
                                v-model="edited_record.on_leave_since"
                                name="on_leave_since"
                                :min-date="0"
                                :editable="can_edit_sensitive_data"
                                :required="!!edited_record.on_leave"
                                :error="has_error('on_leave_since')"
                                @input="save_field"
                            />
                        </div>
                        <div v-if="!!edited_record && !!edited_record.on_leave && !edited_record.proxy" class="uk-width-3-5 uk-text-right lam-label-column">
                            <div class="uk-form-controls-text">
                                Until
                            </div>
                        </div>
                        <div v-if="!!edited_record&&!!edited_record.on_leave" class="uk-width-2-5">
                            <form-date-input
                                id="on_leave_until"
                                v-model="edited_record.on_leave_until"
                                name="on_leave_until"
                                :min-date="0"
                                :editable="can_edit_sensitive_data"
                                :required="!!edited_record.on_leave"
                                :error="has_error('on_leave_until')"
                                @input="save_field"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <contact-info
                v-if="!!edited_record && !edited_record.proxy"
                entity="user"
                :owner-id="edited_record.id"
                owner-type="App.User"
                :editable="can_edit_record_data"
            />

            <div class="uk-accordion">
                <h3 class="uk-accordion-title">
                    System Settings
                </h3>
                <div class="uk-accordion-content">
                    <h5>Access</h5>
                    <form-select
                        v-if="is_db_admin_active"
                        id="role"
                        name="role"
                        v-model="edited_record.role"
                        :options="filtered_roles"
                        :required="true"
                        :editable="can_edit_record_data"
                        class="uk-margin-small-bottom"
                        @input="save_field"
                    />
                    <div v-if="!!edited_record">
                        {{ Object.values($root.constants.roles).find(role => role.id === edited_record.role).name }}
                        <div v-if="edited_record.is_db_admin">
                            <small class="uk-text-muted">(* Also a database administrator)</small>
                        </div>
                    </div>

                    <div v-if="is_settings_admin || is_db_admin_active" class="uk-grid uk-grid-small uk-margin-top">
                        <div v-if="is_settings_admin" class="uk-width-1-3">
                            <form-checkbox
                                id="is_settings_admin"
                                v-model="edited_record.is_settings_admin"
                                name="is_settings_admin"
                                :editable="!!edited_record && !edited_record.proxy"
                                :error="has_error('is_settings_admin')"
                                @input="save_field"
                            >
                                Settings Admin
                            </form-checkbox>
                        </div>
                        <div v-if="is_db_admin_active" class="uk-width-1-3">
                            <form-checkbox
                                id="is_db_admin"
                                v-model="edited_record.is_db_admin"
                                name="is_db_admin"
                                :editable="can_edit_record_data && !!edited_record && !edited_record.proxy"
                                :error="has_error('is_db_admin')"
                                @input="save_field"
                            >
                                DB Admin
                            </form-checkbox>
                        </div>
                        <div v-if="is_db_admin_active" class="uk-width-1-3">
                            <form-checkbox
                                id="proxy"
                                v-model="edited_record.proxy"
                                name="proxy"
                                :error="has_error('proxy')"
                                :editable="can_edit_record_data"
                                @input="save_field"
                            >
                                Placeholder
                            </form-checkbox>
                        </div>
                    </div>

                    <div v-if="!!edited_record && !edited_record.proxy" class="uk-grid uk-grid-small uk-margin-top">
                        <div class="uk-width-1-1">
                            <form-checkbox
                                id="time_off_view"
                                v-model="edited_record.time_off_view"
                                name="time_off_view"
                                :editable="can_edit_record_data && is_db_admin_active"
                                :error="has_error('time_off_view')"
                                @input="save_field"
                            >
                                Can View Time Off Requests
                            </form-checkbox>
                        </div>
                        <div class="uk-width-1-1">
                            <form-checkbox
                                id="closeout_manager"
                                v-model="edited_record.closeout_manager"
                                name="closeout_manager"
                                :editable="can_edit_record_data && is_db_admin_active"
                                :error="has_error('closeout_manager')"
                                @input="save_field"
                            >
                                Manages Project Closeouts
                            </form-checkbox>
                        </div>
                    </div>

                    <div v-if="is_active && !!edited_record && !edited_record.proxy && (me || is_db_admin_active)" class="uk-margin-top">
                        <h5 class="uk-text-center">Assigned Color</h5>
                        <swatches :value="edited_record.hex_color||''" :palette="color_palette" @input="color_changed" class="uk-small" />
                        <p class="uk-text-small uk-text-muted uk-text-center">(For graphs, mainly)</p>
                    </div>

                    <div v-if="is_active && !!edited_record && !edited_record.proxy && (me || is_db_admin_active)" class="uk-grid uk-grid-small uk-margin-top">
                        <div class="uk-width-1-10 uk-text-right lam-label-column">
                            <div class="uk-form-controls-text">X</div>
                        </div>
                        <div class="uk-width-2-10 uk-margin-small-bottom">
                            <form-input
                                id="x"
                                name="x"
                                v-model="edited_record.load_lines.x"
                                type="number"
                                :min="0"
                                format="0,0"
                                glyph="percent"
                                :editable="true"
                                :required="false"
                                class="uk-width-1-1 uk-display-inline-block uk-margin-small-left"
                                @input="save_load_lines"
                            />
                        </div>
                        <div class="uk-width-1-10 uk-text-right lam-label-column">
                            <div class="uk-form-controls-text">Y</div>
                        </div>
                        <div class="uk-width-2-10 uk-margin-small-bottom">
                            <form-input
                                id="y"
                                name="y"
                                v-model="edited_record.load_lines.y"
                                type="number"
                                :min="1"
                                format="0,0"
                                glyph="percent"
                                :editable="true"
                                :required="false"
                                class="uk-width-1-1 uk-display-inline-block uk-margin-small-left"
                                @input="save_load_lines"
                            />
                        </div>
                        <div class="uk-width-1-10 uk-text-right lam-label-column">
                            <div class="uk-form-controls-text">Z</div>
                        </div>
                        <div class="uk-width-2-10 uk-margin-small-bottom">
                            <form-input
                                id="z"
                                name="z"
                                v-model="edited_record.load_lines.z"
                                type="number"
                                :min="1"
                                format="0,0"
                                glyph="percent"
                                :editable="true"
                                :required="false"
                                class="uk-width-1-1 uk-display-inline-block uk-margin-small-left"
                                @input="save_load_lines"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-accordion">
                <h3 class="uk-accordion-title">
                    Notifications
                </h3>
                <div class="uk-accordion-content">
                    <div class="uk-grid uk-grid-small uk-margin-top">
                        <div
                            v-for="notification in $root.constants.notifications"
                            :key="notification.id"
                            class="uk-width-1-1"
                        >
                            <form-checkbox
                                :id="`notification-${notification.id}`"
                                :value="is_notified(notification.id)"
                                name="notify"
                                :editable="can_edit_record_data && is_db_admin_active"
                                class="uk-margin-small-bottom"
                                @input="toggle_notification($event, notification.id)"
                            >
                                {{ notification.name }}
                            </form-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="right-panel-actions">
            <div v-if="!is_db_admin_active && !!edited_record && !edited_record.proxy" class="uk-margin-top">
                <base-button
                    v-if="!is_active"
                    flavor="link"
                    size="small"
                    :disabled="true"
                    class="uk-width-1-1"
                >
                    Inactive
                </base-button>
            </div>
            <base-button
                v-else-if="is_active && !!edited_record && !edited_record.proxy"
                size="small"
                @click.native.prevent="record_delete"
                class="uk-width-1-1 uk-margin-top"
            >
                Inactivate
            </base-button>
            <div v-else-if="!!edited_record && !edited_record.proxy" class="uk-grid uk-grid-small uk-margin-top">
                <div v-if="can_delete_data" class="uk-width-1-2">
                    <base-button
                        color="danger"
                        size="small"
                        @click.native.prevent="confirm_record_delete"
                        class="uk-width-1-1"
                    >
                        Delete
                    </base-button>
                </div>
                <div :class="{'uk-width-1-2': can_delete_data, 'uk-width-1-1': !can_delete_data}">
                    <base-button
                        size="small"
                        @click.native.prevent="record_restore"
                        class="uk-width-1-1"
                    >
                        Re-activate
                    </base-button>
                </div>
            </div>
        </div>
        <div v-if="!!edited_record" slot="left-panel">
            <div class="uk-accordion">
                <h3 class="uk-accordion-title lam-tight">
                    Projects
                </h3>
                <div class="uk-accordion-content lam-tight">
                    <project-data-table
                        id="user-projects"
                        context="user"
                        :context-id="edited_record.id"
                    />
                </div>

                <h3 class="uk-accordion-title lam-tight">
                    Prospective Projects
                </h3>
                <div class="uk-accordion-content lam-tight">
                    <project-data-table
                        id="user-prospective-projects"
                        context="user"
                        :context-id="edited_record.id"
                        :active="false"
                    />
                </div>

                <h3 v-if="can_view_sensitive_data" class="uk-accordion-title">
                    Benefits
                </h3>
                <div v-if="can_view_sensitive_data" class="uk-accordion-content">
                    <table class="uk-table">
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th>Allotted</th>
                                <th>Used</th>
                                <th>Left</th>
                            </tr>
                        </thead>
                        <tbody>
                            <benefit-row :record="edited_record" prefix="vacation_hours" label="Vacation Time" :editable="false&&can_edit_sensitive_data"></benefit-row>
                            <!--
                            <benefit-row :record="edited_record" prefix="holiday_hours" label="Holiday Time" :editable="false&&can_edit_sensitive_data"></benefit-row>
                            //-->
                            <benefit-row :record="edited_record" prefix="days_of_service" label="Day Of Service" :editable="false&&can_edit_sensitive_data"></benefit-row>
                            <benefit-row :record="edited_record" prefix="parental_leave_hours" label="Parental Leave" :editable="false&&can_edit_sensitive_data"></benefit-row>
                            <benefit-row :record="edited_record" prefix="sick_hours" label="Sick Time" :editable="false&&can_edit_sensitive_data"></benefit-row>
                            <benefit-row :record="edited_record" prefix="bereavement_hours" label="Bereavement Time" :editable="false&&can_edit_sensitive_data"></benefit-row>
                            <benefit-row :record="edited_record" prefix="professional_development_hours" label="Professional Dev. Time" :editable="false&&can_edit_sensitive_data"></benefit-row>
                            <benefit-row :record="edited_record" prefix="professional_development_stipend" label="Professional Dev. Stipend" :editable="false&&can_edit_sensitive_data" :monetary="true"></benefit-row>
                            <benefit-row :record="edited_record" prefix="membership_stipend" label="Memberships Stipend" :editable="false&&can_edit_sensitive_data" :monetary="true"></benefit-row>
                            <!--
                            <benefit-row :record="edited_record" prefix="medical_stipend" label="Medical Stipend" :editable="false&&can_edit_sensitive_data" :monetary="true"></benefit-row>
                            //-->
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </record-editor>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"
import { Swatches } from "vue-color"
import material from "material-colors"

import is_record_editor from "../../mixins/IsRecordEditor"

import FormInput from "../../ui/FormInput"
import FormSelect from "../../ui/FormSelect"
import FormCheckbox from "../../ui/FormCheckbox"
import FormDateInput from "../../ui/FormDateInput"
import ProjectDataTable from "../../ui/DataTable/ProjectDataTable"
import BaseButton from "../../ui/BaseButton"
import ContactInfo from "../../ui/ContactInfo"
import BenefitRow from "./BenefitRow"
import PasswordField from "./PasswordField"

const colorMap = [
    "red", "pink", "purple", "deepPurple", "blue",
    "cyan", "teal", "green", "lime",
    "yellow", "orange",
    "brown"
]
const colorLevel = ["900", "500", "100"]
const customColorLevels = {
    deepPurple: ["700", "500", "300"],
    cyan: ["900", "700", "500"]
}

export default {
    mixins: [is_record_editor],
    components: {
        FormInput,
        FormSelect,
        FormCheckbox,
        FormDateInput,
        ProjectDataTable,
        BaseButton,
        ContactInfo,
        BenefitRow,
        PasswordField,
        Swatches
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_studio_records () {
            return this.entity_records("studio")
        },
        raw_project_records () {
            return this.entity_records("project")
        },
        raw_project_user_records () {
            return this.entity_records("project_user")
        },
        raw_notification_subscription_records () {
            return this.entity_records("notification_subscription")
        },
        studios () {
            return this.raw_studio_records
        },
        projects () {
            return Object.values(this.raw_project_records)
        },
        project_users () {
            return Object.values(this.raw_project_user_records)
        },
        me () {
            return this.profile && this.edited_record && (this.profile.id === this.edited_record.id)
        },
        filtered_roles () {
            return this.roles.filter(role => (role.slug !== "inactive") || (this.edited_record && (role.id === this.edited_record.role)))
        },
        is_active () {
            const record = this.edited_record
            return !!record && !record.deleted_at
        },
        can_view_sensitive_data () {
            return this.me || (!this.is_some_designer && !this.is_associate && !this.is_senior_associate) || this.is_db_admin_active
        },
        can_edit_record_data () {
            if(!this.entity) console.error(this.$root.translate("IsRecordEditor has no entity defined."))

            if(!this.profile) return false
            const record = this.edited_record
            if(!!record && !!record.deleted_at) return false
            if(this.is_db_admin_active) return true
            let can = true
            if(this.entity === "user") can = (record && (record.id === this.profile.id))
            return !!can
        },
        can_edit_sensitive_data () {
            const record = this.edited_record
            return !!record && !record.deleted_at && (this.is_administrator || this.is_db_admin_active)
        },
        page_title () {
            if(!this.edited_record) return "user"
            return this.edited_record.name + " (" + this.edited_record.initials + ")"
        },
        color_palette () {
            const colors = []
            colorMap.forEach((type) => {
                var typeColor = []
                if(type.toLowerCase() === "black" || type.toLowerCase() === "white") {
                    typeColor = typeColor.concat(["#000000", "#FFFFFF"])
                } else {
                    const levels = customColorLevels[type] || colorLevel
                    levels.forEach((level) => {
                        const color = material[type][level]
                        typeColor.push(color.toUpperCase())
                    })
                }
                colors.push(typeColor)
            })
            // console.log(colors.join(","))
            return colors
        }
    },
    methods: {
        grab_record_id () {
            if(!this.can_view_record_data) this.record_id = this.profile_id
            else this.record_id = this.$route.params.id || this.profile.id
        },
        color_changed (color) {
            this.$store.dispatch("RECORD_SAVE", {
                entity: "user",
                id: this.edited_record.id,
                data: { hex_color: color.hex }
            })
        },
        save_load_lines () {
            this.save_field(this.edited_record.load_lines, "load_lines")
        },
        confirm_record_delete () {
            this.$confirm(
                {
                    type: "error",
                    title: this.$root.translate("Delete Record"),
                    message: this.$root.translate("Do you really want to delete this record? There is no undo, and all their logged time will be deleted..."),
                    cancel: this.$root.translate("Keep"),
                    ok: this.$root.translate("Delete"),
                    then: (confirmed) => {
                        if(confirmed) this.record_delete()
                    }
                },
                "delete-record"
            )
        },
        record_deleted (record) {
            this.$router.push({ name: "user.list" })
        },
        notification_subscription (notification_id) {
            if(!this.edited_record || !this.edited_record.id) return null
            return this.raw_notification_subscription_records.find(subscription => {
                return (subscription.user_id === this.edited_record.id) && (subscription.notification === notification_id)
            })
        },
        is_notified (notification_id) {
            const subscription = this.notification_subscription(notification_id)
            return !!subscription && !subscription.inactive
        },
        toggle_notification (notify, notification_id) {
            const subscription = this.notification_subscription(notification_id)
            if(!subscription && notify) {
                this.$store.dispatch("CREATE_RECORD", {
                    entity: "notification_subscription",
                    data: {
                        user_id: this.edited_record.id,
                        notification: notification_id
                    }
                }).then(record => {
                }).catch(error => {
                    this.$error(error.message)
                })
            } else if(subscription) {
                this.$store.dispatch("RECORD_SAVE", {
                    entity: "notification_subscription",
                    id: subscription.id,
                    data: { inactive: !notify }
                }).catch(error => {
                    this.$error(error.message)
                })
            }
        },
        disconnect_google () {
            this.save_field(null, "google_oauth_token")
        }
    },
    data () {
        return {
            entity: "user",
            relation_ids: ["contact_method", "notification_subscription"]
        }
    }
}
</script>
